import FormattedMessage from 'I18n/components/FormattedMessage';
import { DownIcon, UpIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { tracker } from '../../_core/common/eventTracking/tracker';
import { useIntersectionObserver } from '../../_core/common/hooks/useIntersectionObserver';
import { FEATURE_GROUPING_ORDER } from '../../featureTableMC0672/data/featureList';
import TableBody from './TableBody';
import TableHeader from './TableHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledTable = styled(View)(({
  theme,
  totalColumnCount,
  firstColumnWidth,
  expanded
}) => ({
  width: '100%',
  background: theme.color['fill-surface-default'],
  borderCollapse: 'separate',
  borderSpacing: theme.space[0],
  marginBlockEnd: theme.space[0],
  'td, th': {
    width: `${(100 - firstColumnWidth) / (totalColumnCount - 1)}%`
  },
  'td:first-child, th:first-child': {
    width: `${firstColumnWidth}%`,
    minWidth: '250px'
  },
  [`tr:nth-child(n + 7)`]: {
    display: expanded ? 'visible ' : 'none '
  }
}));
const FeatureTableMC0673 = ({
  apiNames,
  headerData,
  onExpand,
  onCollapse
}) => {
  const [expanded, setExpanded] = useState(false);
  const handleToggleExpand = () => {
    setExpanded(prev => !prev);
  };
  const featureTableRef = useRef(null);
  useIntersectionObserver({
    onIntersect: () => {
      tracker.track('featureTableInteraction', {
        action: 'scrolled-in-view',
        screen: 'sales'
      });
    },
    targetRef: featureTableRef
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledTable, {
      as: "table",
      totalColumnCount: apiNames.length + 1,
      firstColumnWidth: 35,
      expanded: expanded,
      ref: featureTableRef,
      children: [/*#__PURE__*/_jsx(TableHeader, {
        headerData: headerData,
        apiNames: apiNames
      }), /*#__PURE__*/_jsx(TableBody, {
        apiNames: apiNames,
        tableBodyData: FEATURE_GROUPING_ORDER
      })]
    }), /*#__PURE__*/_jsx(Button, {
      marginInlineStart: "100",
      use: "transparent",
      onClick: e => {
        if (expanded) {
          onCollapse === null || onCollapse === void 0 || onCollapse(e);
        } else {
          onExpand === null || onExpand === void 0 || onExpand(e);
        }
        tracker.track('featureTableInteraction', {
          action: `clicked-${expanded ? 'collapse' : 'expand'}-table`,
          screen: 'sales'
        });
        handleToggleExpand();
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: expanded ? 'upgrades.featureTable.body.collapse' : 'upgrades.featureTable.body.expand'
        }), expanded ? /*#__PURE__*/_jsx(UpIcon, {
          color: "temp-do-not-use-fill-secondary-pressed"
        }) : /*#__PURE__*/_jsx(DownIcon, {
          color: "temp-do-not-use-fill-secondary-pressed"
        })]
      })
    })]
  });
};
export default FeatureTableMC0673;